<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h1>{{ meta.title }}</h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <data-table
            :model="trials.model"
            :headers="trials.headers"
            :selected.sync="trials.selected"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import asyncComponent from '@/utils/asyncComponent';
import Trial from '@/orm/models/Trial';
import { CONST } from '@/utils';


let getOffset = (el) => {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
};

let tickingFactory = (execFunction) => {
  let ticking = false;
  return (event) => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(() => {
        execFunction(event);
        ticking = false;
      });
    }
  }
};

let autoFixedHeader = () => {
  // all code present below because position sticky doesn't work correct with overflow ...

  let table = document.querySelector("table");
  let thead = document.querySelector("table > thead");

  let { left, top } = getOffset(table);
  let topPosition = (top - thead.offsetHeight);
  let viscousOffset = Math.ceil(thead.offsetHeight / 2)

  let hasFixedHeader = thead.classList.contains('table-header-fixed')

  if (!hasFixedHeader && window.scrollY >= topPosition + viscousOffset) {
    // sync columns width
    let tds = document.querySelectorAll("table > tbody > tr:nth-child(1) > td");
    let ths = document.querySelectorAll("table > thead th");

    for(let i=0; i<tds.length; i++) {
      let { width } = tds[i].getBoundingClientRect();
      tds[i].style.cssText = `min-width: ${width}px`;
      if (ths[i]) {
        ths[i].style.cssText = `min-width: ${width}px`;
      }
    }

    thead.classList.add('table-header-fixed');
  }

  if (hasFixedHeader) {
    if (window.scrollY >= topPosition - viscousOffset) {
      thead.style.cssText = `left: ${left}px`; // sync horizontal position
    } else {
      // reset styles
      thead.classList.remove('table-header-fixed');
      thead.style.cssText = '';
      let tds = document.querySelectorAll("table > tbody > tr:nth-child(1) > td");
      let ths = document.querySelectorAll("table > thead th");
      for (let i = 0; i < tds.length; i++) {
        tds[i].style.cssText = '';
      }
      for (let i = 0; i < ths.length; i++) {
        ths[i].style.cssText = '';
      }
    }
  }

}

let onWindowScroll = tickingFactory(autoFixedHeader);

export default {
  name: 'AllTrialsDashboard',
  data() {
    return {
      trials: {
        search: '',
        headers: CONST.trial.headers,
        selected: [],
        model: Trial,
      },
    };
  },
  mounted() {
    window.addEventListener("scroll", onWindowScroll);
    window.addEventListener("wheel", onWindowScroll); // wheel event for horizontal scroll
  },
  destroyed() {
    window.removeEventListener("scroll", onWindowScroll);
    window.removeEventListener("wheel", onWindowScroll);
  },
  computed: {
    meta() {
      return this.$route.meta;
    },
  },
  methods: {},
  components: {
    dataTable: asyncComponent({
      component: 'components/dashboards/ALL/dataTable',
    }),
  },
};
</script>

<style>
  .table-header-fixed {
    position: fixed;
    top: 0;
    background-color: white;
  }
</style>
